import { render } from "./PhotosAndMap.vue?vue&type=template&id=1edcc3dc"
import script from "./PhotosAndMap.vue?vue&type=script&lang=js"
export * from "./PhotosAndMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__